import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getLanguageData } from '@/lang/utils';

export const useLang = () => {
  const { locale } = useI18n();
  const language = computed(() => {
    return getLanguageData(locale.value);
  });

  return {
    language,
  };
};
